import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Button, Alert, Container } from 'react-bootstrap';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [contact, setContact] = useState({ email: '', message: '' });
  const [contactSent, setContactSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  const handleContact = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent('SpotiBot - Zugriffsanfrage');
    const body = encodeURIComponent(
      `Hallo,\n\nich würde gerne SpotiBot nutzen.\n\nMeine E-Mail-Adresse: ${contact.email}\n\n${contact.message}\n\nViele Grüße`
    );
    window.location.href = `mailto:info@mrroonix.com?subject=${subject}&body=${body}`;
    setContactSent(true);
    setContact({ email: '', message: '' });
  };

  return (
    <div
      className="d-flex flex-column align-items-center min-vh-100"
      style={{ background: '#0f0f1a', paddingTop: '5vh', paddingBottom: '2rem' }}
    >
      <Container style={{ maxWidth: 420 }}>
        {/* ── Login ──────────────────────────────────────────────── */}
        <div className="text-center mb-4">
          <h2 className="text-white">🎵 SpotiBot</h2>
          <p style={{ color: '#a0a8c0' }}>Streamer Music Platform</p>
        </div>
        <Card bg="dark" text="white" className="border-secondary shadow mb-5">
          <Card.Body className="p-4">
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Benutzername</Form.Label>
                <Form.Control
                  type="text"
                  value={form.username}
                  onChange={(e) => setForm({ ...form, username: e.target.value })}
                  className="bg-dark text-white border-secondary"
                  required
                  autoFocus
                />
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>Passwort</Form.Label>
                <Form.Control
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  className="bg-dark text-white border-secondary"
                  required
                />
              </Form.Group>
              <Button type="submit" variant="success" className="w-100" disabled={loading}>
                {loading ? 'Einloggen…' : 'Login'}
              </Button>
            </Form>
          </Card.Body>
        </Card>

        {/* ── Zugriffsanfrage ────────────────────────────────────── */}
        <div className="text-center mb-3">
          <h6 style={{ color: '#8892aa', letterSpacing: '0.08em', fontSize: '0.75rem' }} className="text-uppercase">
            Kein Zugang? Zugang anfragen
          </h6>
        </div>
        <Card bg="dark" text="white" className="border-secondary shadow mb-4">
          <Card.Body className="p-4">
            <p style={{ color: '#b0b8cc' }} className="small mb-3">
              SpotiBot ist aktuell nicht öffentlich registrierbar. Du kannst mich kontaktieren und
              anfragen, ob ich dir Zugang einrichten kann.
            </p>
            {contactSent && (
              <Alert variant="success" className="py-2 small">
                Dein E-Mail-Client sollte sich geöffnet haben. Einfach absenden! ✉️
              </Alert>
            )}
            <Form onSubmit={handleContact}>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#c8cfe0' }} className="small">Deine E-Mail-Adresse</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="deine@email.de"
                  value={contact.email}
                  onChange={(e) => setContact({ ...contact, email: e.target.value })}
                  className="bg-dark text-white border-secondary"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#c8cfe0' }} className="small">Warum möchtest du SpotiBot nutzen?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Kurze Beschreibung – wer du bist, für welchen Channel du den Bot nutzen möchtest, …"
                  value={contact.message}
                  onChange={(e) => setContact({ ...contact, message: e.target.value })}
                  className="bg-dark text-white border-secondary"
                  required
                  style={{ resize: 'none' }}
                />
              </Form.Group>
              <Button type="submit" variant="outline-primary" className="w-100" size="sm">
                ✉️ Anfrage senden
              </Button>
            </Form>
          </Card.Body>
        </Card>

        {/* ── Footer ─────────────────────────────────────────────── */}
        <footer className="text-center" style={{ fontSize: '0.75rem', color: '#8892aa' }}>
          <span>
            Ein Projekt von{' '}
            <a href="https://mrroonix.com" target="_blank" rel="noreferrer" style={{ color: '#a0b4d0' }}>
              mRoonix
            </a>
            {' · '}
            <a
              href="https://mein.online-impressum.de/mrroonix/"
              target="_blank"
              rel="noreferrer"
              style={{ color: '#a0b4d0' }}
            >
              Impressum
            </a>
            {' · '}
            <a href="mailto:info@mrroonix.com" style={{ color: '#a0b4d0' }}>
              info@mrroonix.com
            </a>
          </span>
        </footer>
      </Container>
    </div>
  );
}
